import React, {
    useEffect,
    useState,
  } from "react";
  
  import { Helmet }
  from "react-helmet-async";
  
  import { getSeoData }
  from "../../networkCalls";
  
  export default function SEO(props) {
  
    const [seoData, setSeoData] =
      useState(null);
  
    useEffect(() => {
      fetchSeo();
    }, []);
  
    const fetchSeo = async () => {
  
      try {
      
        const currentUrl =
          "https://staginghonda.wipl.co.in";
  
        const res =
          await getSeoData(props.url);
  
        if (
          res?.data?.status === 1
        ) {
          console.log('>>>>>',res)
          setSeoData(
            res.data.seo_data
          );
        }
  
      } catch (error) {
        console.log(error);
      }
  
    };
  
    useEffect(() => {
      if (seoData) {
        console.log(seoData);
        console.log(seoData.schema_markup);
      }
    }, [seoData]);

    return (
      <Helmet>
  
        {/* TITLE */}
        <title>
          {
            seoData?.meta_title
          }
        </title>
  
        {/* DESCRIPTION */}
        <meta
          name="description"
          content={
            seoData?.meta_description
          }
        />
  
        {/* KEYWORDS */}
        <meta
          name="keywords"
          content={
            seoData?.meta_keywords
          }
        />
  
        {/* CANONICAL */}
        <link
          rel="canonical"
          href={
            seoData?.canonical_url
          }
        />
  
        {/* OPEN GRAPH */}
        <meta
          property="og:title"
          content={
            seoData?.og_title
          }
        />
  
        <meta
          property="og:description"
          content={
            seoData?.og_description
          }
        />
  
        <meta
          property="og:image"
          content={
            seoData?.og_image
          }
        />
  
        <meta
          property="og:url"
          content={
            seoData?.url
          }
        />
  
        {/* TWITTER */}
        <meta
          name="twitter:title"
          content={
            seoData?.twitter_title
          }
        />
  
        <meta
          name="twitter:description"
          content={
            seoData?.twitter_description
          }
        />
  
  
  {/* <<<<<<<<<< */}
 {/* SCHEMA MARKUP */}
 {seoData?.schema_markup && (
  <script type="application/ld+json">
    {seoData.schema_markup}
  </script>
)}


      </Helmet>
    );
  }